export type PortOption = {
  label: string;
  value: string;
};

type PortLike = {
  portCode?: string | number | null;
  portName?: string | null;
};

export const buildPortOptions = <T extends PortLike>(
  ports: readonly T[] | null | undefined,
): PortOption[] => {
  const valid = (ports ?? [])
    .filter((port) => !!(port?.portCode && port?.portName))
    .map((port) => ({
      portCode: String(port.portCode),
      portName: String(port.portName),
    }));

  valid.sort((a, b) => {
    const byName = a.portName.localeCompare(b.portName);
    return byName || a.portCode.localeCompare(b.portCode);
  });

  return valid.map(({ portName, portCode }) => ({
    label: `${portName} (${portCode})`,
    value: portCode,
  }));
};
